module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card rule"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title",
    staticStyle: {
      "font-weight": "400"
    }
  }, [_vm._v(_vm._s(_vm.rule.name))]), _vm._v(" "), _c('a', {
    staticClass: "card-header-icon",
    on: {
      "click": _vm.toggleExpansion
    }
  }, [_vm._m(0)])]), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v(_vm._s(_vm.rule.description))]), _vm._v(" "), _c('div', {
    staticClass: "rule-definition"
  }, [(_vm.ruleConditions.length !== 0) ? _c('span', {
    staticClass: "feature-matrix"
  }, _vm._l((_vm.ruleConditions), function(feature) {
    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "rule-definition-separator"
  }, [_vm._v("→")]), _vm._v(" "), (_vm.ruleApplies.length !== 0) ? _c('span', {
    staticClass: "feature-matrix"
  }, _vm._l((_vm.ruleApplies), function(feature) {
    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "rule-definition-separator"
  }, [_vm._v("/")]), _vm._v(" "), (_vm.hasBoundaryFirst) ? _c('span', {
    staticClass: "boundary"
  }, [_vm._v("\n        Utterance [\n      ")]) : _vm._e(), _vm._v(" "), (_vm.ruleBefore.length !== 0) ? _c('span', {
    staticClass: "feature-matrix"
  }, _vm._l((_vm.ruleBefore), function(feature) {
    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "rule-definition-separator"
  }, [_vm._v("__")]), _vm._v(" "), (_vm.ruleAfter.length !== 0) ? _c('span', {
    staticClass: "feature-matrix"
  }, _vm._l((_vm.ruleAfter), function(feature) {
    return _c('div', [_vm._v("\n          " + _vm._s(feature) + "\n        ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.hasBoundaryLast) ? _c('span', {
    staticClass: "boundary"
  }, [_vm._v("\n        ] Utterance\n      ")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dac5632!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rule.vue
// module id = 38
// module chunks = 2